import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const GuestCounterWrapper = styled.div`
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.md`
    padding: 21px 26px;
    border: 1px solid #efefef;
    border-radius: 3px;
  `};
`;

export const GuestCounterLabel = styled.label`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;
